// Get base URL (domain only, no path)
function getBaseUrl() {
  const host = window.location.hostname;
  const protocol = window.location.protocol;
  return `${protocol}//${host}`;
}

document.addEventListener('DOMContentLoaded', function () {
  const globalNav = document.getElementById('global-nav');
  if (!globalNav) return;

  // Top-Level Domains
  const regionTldMap = {
    '.com': 'US',
    '.ca': 'CA',
    '.com.co': 'Co',
    '.com.mx': 'MX',
    '.it': 'IT',
    '.me': 'ME',
    '.es': 'ES',
    '.co.uk': 'EU',
    '.sg': 'AS',
    '.au': 'AU',
    '.co.in': 'IN',
  };

  const sortedTlds = Object.keys(regionTldMap).sort((a, b) => b.length - a.length);

  function matchDomain(str) {
    for (const tld of sortedTlds) {
      if (str.endsWith(tld)) {
        return tld;
      }
    }
    return '.com'; // Default is US (mheducation.com)
  }

  // Get current location domains
  function getCurrentRegionTld() {
    const host = window.location.hostname;
    return matchDomain(host);
  }

  // Extract business unit from URL path
  function getBusinessUnitFromPath() {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('prek12') || path.includes('prek-12')) {
      return 'prek-12';
    } else if (path.includes('highered') || path.includes('higher-ed')) {
      return 'highered';
    }
    return null;
  }

  const regionSelectorOffcanvas = globalNav.querySelector('#region-selector');

  // Build pathRegionMap dynamically from authored data attribute
  const pathRegionMap = JSON.parse(regionSelectorOffcanvas?.getAttribute('data-path-regions') || '{}');

  // Extract region prefix from URL path first segment (e.g. /gb/en/ → "GB")
  function getRegionFromPath() {
    const segments = window.location.pathname.toLowerCase().split('/');
    const firstSegment = segments.find((s) => s.length > 0);
    return firstSegment ? pathRegionMap[firstSegment] || null : null;
  }

  const regionSelectorButtons = globalNav.querySelectorAll('#region-selector-btn');
  const currentTld = getCurrentRegionTld();
  const currentBusinessUnit = getBusinessUnitFromPath();
  const currentRegionPrefix = getRegionFromPath() || regionTldMap[currentTld] || 'US';
  let currentRegion;

  function setSelectedRegionAndBusinessUnit() {
    // Remove all existing selected classes
    const allElements = regionSelectorOffcanvas?.querySelectorAll('.selected');
    allElements?.forEach((element) => element.classList.remove('selected'));

    // Find the region element first
    const selectedRegionElement = regionSelectorOffcanvas?.querySelector(
      `[data-country-prefix="${currentRegionPrefix}"]`
    );

    if (selectedRegionElement) {
      currentRegion = selectedRegionElement.textContent.trim();

      // Check if this element has business units and if we have a business unit context
      if (selectedRegionElement.classList.contains('open-submenu') && currentBusinessUnit) {
        // Business unit context exists - mark level 3 as selected, not level 2
        const businessUnitSelected = setSelectedBusinessUnit(selectedRegionElement);

        // Only mark level 2 as selected if business unit selection failed
        if (!businessUnitSelected) {
          selectedRegionElement.classList.add('selected');
          selectedRegionElement.setAttribute('aria-current', 'true');
        }
      } else {
        // No business unit context - mark level 2 as selected
        selectedRegionElement.classList.add('selected');
        selectedRegionElement.setAttribute('aria-current', 'true');
      }
    }
  }

  function setSelectedBusinessUnit(parentButton) {
    // Find the corresponding level3Menu
    const countryPrefix = parentButton.getAttribute('aria-controls');
    if (countryPrefix && currentBusinessUnit) {
      const level3Menu = regionSelectorOffcanvas?.querySelector(`#${countryPrefix}`);
      if (level3Menu) {
        // Use direct selector for single business unit
        const selectedBusinessUnitLink = level3Menu.querySelector(`a[data-selected-bu="${currentBusinessUnit}"]`);
        if (selectedBusinessUnitLink) {
          selectedBusinessUnitLink.classList.add('selected');
          return true; // Return true to indicate successful business unit selection
        }
      }
    }
    return false; // Return false if business unit selection failed
  }

  setSelectedRegionAndBusinessUnit();

  function setRegionSelectorButtonLabel() {
    regionSelectorButtons.forEach((regionSelectorButton) => {
      const labelSpan = regionSelectorButton.querySelector('span');
      if (labelSpan) {
        labelSpan.textContent = currentRegionPrefix;
        regionSelectorButton.setAttribute('aria-label', `Region selected: ${currentRegionPrefix}`);
      }
    });
  }
  setRegionSelectorButtonLabel();

  function setRegionSelectButtonAnalytics() {
    regionSelectorButtons.forEach((regionSelectorButton) => {
      regionSelectorButton.setAttribute('data-layer-selected', currentRegion || currentRegionPrefix);
      regionSelectorButton.setAttribute(
        'data-layer-href',
        `${
          getBaseUrl() +
          `/?utm_source=${currentRegionPrefix.toLowerCase()}&utm_medium=header_link&utm_campaign=region_select`
        }`
      );
    });
  }
  setRegionSelectButtonAnalytics();

  /*
   * The offcanvas element is inside the global nav logic that handle display none and block responsiveness.
   * This will remove the d-none from the offcanvas parent <li> to render the element for small screens.
   */
  function showRegionSelectorOffcanvasOnMobile(offcanvasEl) {
    if (!offcanvasEl) return;
    const parent = offcanvasEl.parentElement;
    if (parent && parent.tagName && parent.tagName.toLowerCase() === 'li') {
      parent.classList.remove('d-none');
      return;
    }
    const liAncestor = offcanvasEl.closest('li');
    if (liAncestor) liAncestor.classList.remove('d-none');
  }
  showRegionSelectorOffcanvasOnMobile(regionSelectorOffcanvas);

  function isOffcanvasVisible(offcanvas) {
    return offcanvas?.classList.contains('show') ?? false;
  }

  function setRegionButtonAriaExpanded(expanded) {
    const value = expanded ? 'true' : 'false';
    regionSelectorButtons.forEach((regionSelectorButton) => {
      try {
        regionSelectorButton.setAttribute('aria-expanded', value);
      } catch (e) {
        console.log(e);
      }
    });
  }

  setRegionButtonAriaExpanded(isOffcanvasVisible(regionSelectorOffcanvas));

  if (regionSelectorOffcanvas && regionSelectorOffcanvas.addEventListener) {
    regionSelectorOffcanvas.addEventListener('show.bs.offcanvas', function () {
      setRegionButtonAriaExpanded(true);
    });
    regionSelectorOffcanvas.addEventListener('shown.bs.offcanvas', function () {
      setRegionButtonAriaExpanded(true);
    });
    regionSelectorOffcanvas.addEventListener('hide.bs.offcanvas', function () {
      setRegionButtonAriaExpanded(false);
    });
    regionSelectorOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
      setRegionButtonAriaExpanded(false);
    });
  }
});
